module.exports = __webpack_public_path__ + "img/appc.4e364bc3.svg";